export const actionTypes = {
  UPDATE_LOCATION: 'UPDATE_LOCATION',
};

const updateLocation = ({ ip, country }) => ({
  type: actionTypes.UPDATE_LOCATION,
  ip,
  country,
});

export { updateLocation };
